export default "__VITE_ASSET__Ci01dX39__"